import React, { useContext } from 'react';
import styled from 'styled-components'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import { updatePortalUser, loadProfile } from '../../../../../api'
import { AuthContext } from '../../../../../auth-context'
import { DashboardContext } from '../../../dashboard-context'
import Button from '../../../../../components/button'
import { ThemeContext } from "styled-components";

const SETTINGS_COLUMNS = ['meal_planner_allowed'];

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`;

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`;

const Description = styled.p`
  color: #5a5a5a;
  font-size: 1rem;
  margin-bottom: 32px;
  
  span {
    font-family: ${props => props.theme.font.primary};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  @media(max-width: 900px) {
    margin-top: 16px;
  }
`;

const CustomButton = styled(Button)`
  background: ${props => props.color ? props.theme.button.background : '#d5d5d5'};
  margin: 0;
  margin-left: 16px;
  &:hover {
    opacity: 0.8;
  }
`;

const SetMealPlanner = (props) => {
  const { user, updateUser } = useContext(AuthContext);
  const { openSnackbar } = useContext(DashboardContext);
  const theme = useContext(ThemeContext);
  const settings_parsed = user.settings;

  const setMealPlanner = (value) => {
    if (settings_parsed.meal_planner_allowed !== value) {
      let newSettings = { ...settings_parsed, meal_planner_allowed: value };
      if (value === false) {
        delete newSettings.meal_planner_allowed;
      }

      updatePortalUser(user.id, {
        settings: JSON.stringify(newSettings),
      })
        .then(() => {
          openSnackbar('Account was successfully updated.', false);
          loadProfile(user.id)
            .then((res) => {
              updateUser(res.data.profile);
            })
            .catch((err) => {
              console.log(err); // Server Error
            });
        })
        .catch((err) => {
          openSnackbar('There was a problem updating your account.', true);
        });
    }
  };

  return (
    <>
      <Container className={props.className}>
        <Label>
          <PlaylistAddCheckIcon /> Meal Planner
        </Label>
        <Description>
          Controls if clients have access to the meal planner feature on the{' '}
          {theme.name === 'AVATAR' ? 'Avatar' : 'Fit Body'} Nutrition App. Only
          owner accounts can change this setting.
        </Description>
        <ButtonContainer>
          <CustomButton
            label="On"
            color={settings_parsed.meal_planner_allowed}
            onClick={() => setMealPlanner(true)}
          />
          <CustomButton
            label="Off"
            color={!settings_parsed.meal_planner_allowed}
            onClick={() => setMealPlanner(false)}
          />
        </ButtonContainer>
      </Container>
    </>
  );
};

export default SetMealPlanner;